export const ENTRY_FILTERS = [
  "All Entries",
  "All Matches",
  "Real matches",
  "False matches",
  "New matches",
] as const;

export type EntryFilter = (typeof ENTRY_FILTERS)[number];

export const ENTRY_FILTER_LABELS: Record<EntryFilter, string> = {
  "All Entries": "All entries",
  "All Matches": "All matches",
  "Real matches": "Real matches",
  "False matches": "False matches",
  "New matches": "New matches",
};
